<template>
  <div class="login-page">
    <HeaderView />
    <div
      class="login-shell"
      :class="{
        'bg-content': $store.state.screenWidth > 375,
        'bg-content-se': $store.state.screenWidth <= 375,
        'bg-content-4': $store.state.screenWidth <= 320,
      }"
    >
      <div class="login-layout">
        <section
          class="login-visual"
          aria-hidden="true"
        >
          <div class="login-brand">
            <img
              src="/static/img/logo/open-house-2026.png"
              alt="RMUTL Open House 2026"
            />
            <div>
              <span>RMUTL</span>
              <strong>OPEN HOUSE</strong>
            </div>
          </div>
          <div class="tech-orbit">
            <div class="tech-core">
              <img
                src="/static/img/mascot/rmutl-laptop.png"
                alt="RMUTL mascot"
              />
            </div>
            <span class="tech-node node-a"><i class="ti ti-qrcode"></i></span>
            <span class="tech-node node-b"><i class="ti ti-school"></i></span>
            <span class="tech-node node-c"><i class="ti ti-bulb"></i></span>
            <span class="tech-node node-d"><i class="ti ti-wifi"></i></span>
          </div>
          <div class="visual-copy">
            <h1>เปิดบ้านราชมงคลล้านนา</h1>
            <p>เปิดประสบการณ์เรียนรู้สายอาชีพและเทคโนโลยี</p>
          </div>
        </section>

        <section class="login-panel">
          <div class="panel-heading">
            <span class="panel-icon">
              <img
                src="/static/img/logo/open-house-2026.png"
                alt="RMUTL Open House 2026"
              />
            </span>
            <div>
              <p>เปิดบ้านราชมงคล</p>
              <h2>เข้าสู่ระบบ</h2>
            </div>
          </div>

          <div class="login-field">
            <label for="citizen">เลขบัตรประชาชนหรือเลขพาสปอร์ต</label>
            <div
              class="input-shell"
              :class="{ 'has-error': checkVal }"
            >
              <i class="ti ti-id-badge-2"></i>
              <input
                type="text"
                maxlength="13"
                v-model="citizen_id"
                id="citizen"
                autocomplete="off"
                placeholder="กรอกเลขบัตรประชาชน หรือ เลขพาสปอร์ต"
                @input="sanitizeCitizenId"
                @keyup="checkVal = false"
                @keyup.enter="validateForm"
              />
            </div>
            <small
              class="login-error"
              v-if="checkVal"
            >
              กรุณากรอกรหัสประจำตัวประชาชนหรือเลขพาสปอร์ตให้ถูกต้อง
            </small>
          </div>

          <button
            class="login-submit"
            @click="validateForm"
          >
            <i class="ti ti-arrow-right"></i>
            <span>เข้าสู่ระบบ</span>
          </button>

          <div class="login-footer">
            <span>ออกแบบและพัฒนาโดย</span>
            <a
              href="https://arit.rmutl.ac.th"
              target="_blank"
            >
              สำนักวิทยบริการและเทคโนโลยีสารสนเทศ
            </a>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderView from './layouts/HeaderView.vue'
import Swal from 'sweetalert2'
import api from '../assets/services'

export default {
  components: {
    HeaderView,
  },
  data () {
    return {
      citizen_id: '',
      checkVal: false,
    }
  },
  methods: {
    sanitizeCitizenId () {
      this.citizen_id = this.citizen_id.replace(/[^a-zA-Z0-9]/g, '')
    },
    validateForm () {
      if (this.citizen_id.length === 13) {
        // if (this.THAIIDCHECK(this.citizen_id) === true) {
        this.Login(this.citizen_id)
        // } else {
        //   this.checkVal = true
        // }
      } else if (this.citizen_id.length === 9) {
        this.Login(this.citizen_id)
      } else {
        this.checkVal = true
      }
    },
    Login (citizenId) {
      this.$store.state.isLoading = true
      api.OAuthCheck(
        this.$store.state.URL,
        { citizenId: citizenId },
        this.header,
        (result) => {
          if (result.status === 'SUCCESS') {
            localStorage.token = result.data.accessToken
            this.OAuth(citizenId)
            this.$router.push('/activity').catch(() => { })
          } else if (result.status === 'NOT_REGISTER') {
            // this.$router.push('/regis/' + citizenId + '?campus=' + (this.$route.query.campus ? this.$route.query.campus : 'chiangmai')).catch(() => {})
            this.$router.push('/regis/' + citizenId).catch(() => { })
          } else {
            Swal.fire({
              title: 'ตรวจสอบ',
              text: result.message,
              icon: 'warning',
              showDenyButton: true,
              showCancelButton: false,
              confirmButtonText: 'ลองใหม่อีกครั้ง',
              denyButtonText: 'ยกเลิก',
            }).then((result) => {
              /* Read more about isConfirmed, isDenied below */
              if (result.isConfirmed) {
                this.Login()
              } else if (result.isDenied) {
                this.citizen_id = ''
              }
            })
            localStorage.clear()
          }
          this.$store.state.isLoading = false
        },
        (error) => {
          this.$store.state.isLoading = false
          Swal.fire({
            title: 'ตรวจสอบ',
            text: JSON.stringify(error),
            icon: 'error',
            showDenyButton: true,
            showCancelButton: false,
            confirmButtonText: 'ลองใหม่อีกครั้ง',
            denyButtonText: 'ยกเลิก',
          }).then((result) => {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
              this.Login()
            } else if (result.isDenied) {
              this.citizen_id = ''
            }
          })
        },
      )
    },
  },
  mounted () {
    const auth = this.callbackToken(this.citizen_id)
    if (auth) {
      this.$router.push('/activity').catch(() => { })
    }
  },
}
</script>

<style scoped>
.login-page {
  min-height: 100vh;
}

.login-shell {
  background: radial-gradient(circle at top left, rgba(218, 169, 78, 0.22), transparent 30%), linear-gradient(135deg, #fffaf0 0%, #f6efe2 44%, #fffdf8 100%) !important;
  padding: 18px !important;
}

.login-layout {
  width: min(1040px, 100%);
  min-height: calc(100% - 8px);
  margin: 0 auto;
  display: grid;
  grid-template-columns: minmax(0, 1.08fr) minmax(320px, 0.92fr);
  gap: 20px;
  align-items: stretch;
}

.login-visual,
.login-panel {
  border: 1px solid rgba(116, 87, 60, 0.12);
  background: rgba(255, 255, 255, 0.84);
  box-shadow: 0 22px 60px rgba(33, 39, 55, 0.13);
  backdrop-filter: blur(14px);
}

.login-visual {
  position: relative;
  min-height: 520px;
  padding: 34px;
  overflow: hidden;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  color: #1b2936;
}

.login-visual::before {
  content: '';
  position: absolute;
  inset: 0;
  background: linear-gradient(rgba(28, 69, 83, 0.07) 1px, transparent 1px), linear-gradient(90deg, rgba(28, 69, 83, 0.07) 1px, transparent 1px);
  background-size: 34px 34px;
  mask-image: linear-gradient(to bottom, #000, transparent 88%);
}

.login-brand,
.visual-copy,
.tech-orbit {
  position: relative;
  z-index: 1;
}

.login-brand {
  display: inline-flex;
  align-items: center;
  gap: 14px;
}

.login-brand img {
  width: 58px;
  height: 58px;
  object-fit: contain;
}

.login-brand span,
.panel-heading p {
  display: block;
  margin: 0;
  color: #7c654f;
  font-size: 13px;
  letter-spacing: 0;
}

.login-brand strong {
  display: block;
  color: #74573c;
  font-size: 22px;
  font-weight: 600;
}

.tech-orbit {
  width: min(360px, 72vw);
  aspect-ratio: 1;
  margin: 8px auto;
  border: 1px solid rgba(185, 130, 46, 0.28);
  border-radius: 50%;
  display: grid;
  place-items: center;
}

.tech-orbit::before,
.tech-orbit::after {
  content: '';
  position: absolute;
  border: 1px solid rgba(116, 87, 60, 0.16);
  border-radius: 50%;
}

.tech-orbit::before {
  inset: 17%;
}

.tech-orbit::after {
  inset: 31%;
}

.tech-core {
  width: 96px;
  height: 96px;
  border-radius: 28px;
  display: grid;
  place-items: center;
  color: #ffffff;
  background: linear-gradient(135deg, #b9822e, #5a3b25);
  box-shadow: 0 18px 36px rgba(185, 130, 46, 0.28);
  font-size: 44px;
}

.tech-core img {
  width: 88%;
  height: 88%;
  object-fit: contain;
}

.tech-node {
  position: absolute;
  width: 58px;
  height: 58px;
  border-radius: 18px;
  display: grid;
  place-items: center;
  color: #9f6f28;
  background: #ffffff;
  border: 1px solid rgba(185, 130, 46, 0.2);
  box-shadow: 0 14px 30px rgba(33, 39, 55, 0.11);
  font-size: 28px;
}

.node-a {
  top: 12%;
  right: 20%;
}

.node-b {
  left: 10%;
  top: 45%;
  color: #74573c;
}

.node-c {
  right: 9%;
  bottom: 24%;
  color: #b9822e;
}

.node-d {
  left: 33%;
  bottom: 5%;
}

.visual-copy h1 {
  max-width: 520px;
  margin: 0 0 12px;
  color: #18242f;
  font-size: 34px;
  line-height: 1.28;
  font-weight: 600;
}

.visual-copy p {
  max-width: 520px;
  margin: 0;
  color: #7c654f;
  font-size: 16px;
  line-height: 1.7;
}

.login-panel {
  min-height: 520px;
  padding: 36px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.panel-heading {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 30px;
}

.panel-icon {
  flex: 0 0 auto;
  width: 52px;
  height: 52px;
  border-radius: 0;
  display: grid;
  place-items: center;
  color: #ffffff;
  background: transparent;
  font-size: 28px;
}

.panel-icon img {
  width: 42px;
  height: 42px;
  object-fit: contain;
}

.panel-heading h2 {
  margin: 0;
  color: #18242f;
  font-size: 32px;
  font-weight: 600;
}

.login-field {
  margin-bottom: 18px;
}

.login-field label {
  display: block;
  margin-bottom: 10px;
  color: #253443;
  font-size: 15px;
  font-weight: 500;
}

.input-shell {
  display: grid;
  grid-template-columns: 24px minmax(0, 1fr);
  gap: 10px;
  align-items: center;
  min-height: 54px;
  padding: 0 16px;
  border: 1px solid #d4dde1;
  border-radius: 8px;
  background: #ffffff;
  color: #8a714f;
  transition: border-color 0.16s ease, box-shadow 0.16s ease;
}

.input-shell:focus-within {
  border-color: #b9822e;
  box-shadow: 0 0 0 4px rgba(185, 130, 46, 0.16);
}

.input-shell.has-error {
  border-color: #d63939;
  box-shadow: 0 0 0 4px rgba(214, 57, 57, 0.12);
}

.input-shell i {
  font-size: 24px;
}

.input-shell input {
  width: 100%;
  min-width: 0;
  border: 0;
  outline: 0;
  color: #18242f;
  background: transparent;
  font-size: 16px;
}

.input-shell input::placeholder {
  color: #a8957e;
}

.login-error {
  display: block;
  margin-top: 8px;
  color: #d63939;
  font-size: 13px;
}

.login-submit {
  width: 100%;
  min-height: 56px;
  border: 0;
  border-radius: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  color: #ffffff;
  background: linear-gradient(135deg, #5a3b25, #b9822e);
  font-size: 20px;
  font-weight: 500;
  box-shadow: 0 16px 28px rgba(116, 87, 60, 0.2);
  transition: transform 0.16s ease, box-shadow 0.16s ease;
}

.login-submit:hover {
  transform: translateY(-1px);
  box-shadow: 0 20px 34px rgba(185, 130, 46, 0.24);
}

.login-submit:active {
  transform: translateY(0);
}

.login-submit i {
  font-size: 24px;
}

.login-footer {
  margin-top: 28px;
  padding-top: 18px;
  border-top: 1px solid rgba(116, 87, 60, 0.12);
  display: grid;
  gap: 6px;
  color: #7c654f;
  font-size: 13px;
  line-height: 1.5;
  text-align: center;
}

.login-footer a {
  color: #9f6f28;
  font-weight: 500;
}

@media (max-width: 991px) {
  .login-shell {
    min-height: calc(100vh - 120px);
    padding: 18px 14px calc(18px + env(safe-area-inset-bottom)) !important;
    display: flex;
    align-items: flex-start;
  }

  .login-visual {
    display: none;
  }

  .login-layout {
    width: min(480px, 100%);
    grid-template-columns: 1fr;
  }

  .login-panel {
    min-height: min(760px, calc(100vh - 156px));
    padding: 148px 26px 42px;
    border: 0;
    border-radius: 28px;
    justify-content: flex-start;
    background: linear-gradient(45deg, transparent 49%, rgba(116, 87, 60, 0.14) 50%, transparent 51%) right 18px top 0 / 220px 220px no-repeat,
      linear-gradient(135deg, transparent 49%, rgba(185, 130, 46, 0.13) 50%, transparent 51%) right -18px top 42px / 240px 240px no-repeat, linear-gradient(180deg, rgba(255, 255, 255, 0.98), rgba(255, 255, 255, 0.94)), #ffffff;
    box-shadow: 0 22px 52px rgba(76, 50, 31, 0.18);
  }

  .login-panel::before {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    width: min(58vw, 280px);
    height: 220px;
    border-top-right-radius: 28px;
    background: linear-gradient(30deg, transparent 44%, rgba(116, 87, 60, 0.16) 45%, rgba(116, 87, 60, 0.16) 46%, transparent 47%) 0 12px / 120px 88px,
      linear-gradient(150deg, transparent 44%, rgba(185, 130, 46, 0.16) 45%, rgba(185, 130, 46, 0.16) 46%, transparent 47%) 56px 0 / 136px 96px, linear-gradient(90deg, transparent 49%, rgba(116, 87, 60, 0.1) 50%, transparent 51%) 120px 40px / 130px 130px;
    opacity: 0.75;
    pointer-events: none;
  }

  .panel-heading {
    position: relative;
    z-index: 1;
    align-items: center;
    margin-bottom: 28px;
  }

  .panel-icon {
    width: 56px;
    height: 56px;
    border-radius: 0;
    color: #8a5d24;
    background: transparent;
    font-size: 46px;
  }

  .panel-icon img {
    width: 56px;
    height: 56px;
  }

  .panel-heading p {
    font-size: 12px;
  }

  .panel-heading h2 {
    font-size: 30px;
  }

  .login-field,
  .login-submit,
  .login-footer {
    position: relative;
    z-index: 1;
  }

  .login-field {
    margin-bottom: 18px;
  }

  .login-field label {
    color: #1f1710;
    font-size: 14px;
  }

  .input-shell {
    min-height: 58px;
    border-color: #2f241b;
    border-radius: 8px;
    background: rgba(255, 255, 255, 0.94);
  }

  .login-submit {
    min-height: 60px;
    border-radius: 12px;
  }

  .login-footer {
    margin-top: 32px;
    padding-top: 22px;
  }
}

@media (max-width: 767px) {
  .login-shell {
    padding: 12px 12px calc(20px + env(safe-area-inset-bottom)) !important;
  }

  .login-layout {
    width: 100%;
    gap: 12px;
  }

  .login-visual {
    min-height: 230px;
    padding: 22px;
  }

  .tech-orbit {
    position: absolute;
    right: -72px;
    top: 18px;
    width: 220px;
    opacity: 0.68;
  }

  .tech-core {
    width: 70px;
    height: 70px;
    border-radius: 22px;
    font-size: 34px;
  }

  .tech-node {
    width: 42px;
    height: 42px;
    border-radius: 14px;
    font-size: 22px;
  }

  .visual-copy h1 {
    max-width: 270px;
    font-size: 24px;
  }

  .visual-copy p {
    max-width: 280px;
    font-size: 14px;
  }

  .login-panel {
    min-height: min(760px, calc(100vh - 148px));
    padding: 140px 26px 40px;
  }

  .panel-heading {
    gap: 12px;
    margin-bottom: 22px;
  }

  .panel-heading h2 {
    font-size: 30px;
  }

  .input-shell input {
    font-size: 15px;
  }

  .input-shell input::placeholder {
    font-size: 14px;
  }

  .login-submit {
    font-size: 18px;
  }
}

@media (max-width: 360px) {
  .login-panel {
    min-height: min(720px, calc(100vh - 138px));
    padding: 126px 24px 34px;
  }

  .visual-copy h1 {
    font-size: 21px;
  }

  .panel-heading h2 {
    font-size: 25px;
  }

  .panel-icon {
    width: 50px;
    height: 50px;
    font-size: 40px;
  }

  .panel-icon img {
    width: 50px;
    height: 50px;
  }

  .login-field label,
  .login-footer {
    font-size: 12px;
  }

  .input-shell input {
    font-size: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue